<template>
  <section>
    <h1 class="text-h3 mb-8">
      Switches
    </h1>
    <v-sheet
      class="mb-4 px-6 py-4"
      outlined
      rounded
    >
      <v-switch
        v-model="switch1"
        label="Standard Switch"
      />
      <v-switch
        v-model="switch2"
        label="Flat Switch"
        flat
      />
      <v-switch
        v-model="switch3"
        label="Inset Switch"
        inset
      />
      <v-divider />
      <v-switch
        v-model="switch1"
        label="Standard Switch (disabled)"
        disabled
      />
      <v-switch
        v-model="switch2"
        label="Flat Switch (disabled)"
        flat
        disabled
      />
      <v-switch
        v-model="switch3"
        label="Inset Switch (disabled)"
        inset
        disabled
      />
    </v-sheet>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/components/switches/">
      <strong>Switches</strong>
    </external-link>
  </section>
</template>

<script>
export default {
  name: 'FormSwitches',
  data: () => ({
    switch1: false,
    switch2: false,
    switch3: false
  })
}
</script>
